import { Flex } from 'antd';
import closeIcon from 'Assets/icons/close.svg';
import { CONSULT_ACCEPTED } from 'Constants/consults';
import { generateIncludeParams } from 'Helpers/utils';
import useIsHealthSummaryUploading from 'Hooks/files/useIsHealthSummaryUploading';
import { func, objectOf, shape, string } from 'prop-types';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toggleAINoteModal } from 'Redux/modules/ui/actions';
import { consultDetails } from 'Redux/modules/webChat/actions';
import { getConversationById } from 'Selectors/webChat/consults';
import { Segment } from 'semantic-ui-react';

import AINoteButton from '../../AINotes/AINoteButton';
import SummaryContent from '../../FinishConsult/SummaryContent/SummaryContent';

import WrapHealthSummaryDetails from './WrapHealthSummaryDetails';

const consultDetailsResponseParams = {
  include: generateIncludeParams({ id: true, health_summary: true }),
};

const ConsultSummary = props => {
  const { closeContextMenu, consult } = props;
  const conversation = useSelector(state =>
    getConversationById(state, state.webChat.conversationActive),
  );

  const {
    data: { enableAiNote },
  } = useSelector(state => state.webChat.doctor);

  const dispatch = useDispatch();

  useEffect(() => {
    if (consult.id) {
      dispatch(consultDetails(consult.id, consultDetailsResponseParams));
    }
  }, [consult?.id, dispatch]);

  const doctor = useSelector(state => state.webChat.doctor.data);

  const { isHealthSummaryUploading, showAlert } = useIsHealthSummaryUploading();

  const handleCheckUploadingAndClose = () => {
    if (isHealthSummaryUploading) {
      showAlert();
    } else {
      closeContextMenu();
    }
  };

  const showAINoteModal = () => {
    dispatch(toggleAINoteModal(true));
  };

  const isOngoing = consult.status === CONSULT_ACCEPTED;
  const isShowAINoteButton = enableAiNote && isOngoing;

  return (
    <Segment.Group className="context-menu">
      <Segment className="menu-header">
        <Flex justify="space-between" align="center" flex={1}>
          <Flex gap={16} align="center">
            <span style={{ fontSize: 16, fontWeight: 600 }}>Consult Summary</span>
            {isShowAINoteButton && <AINoteButton buttonText="AI Notes" onClick={showAINoteModal} />}
          </Flex>
          <button
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              outline: 'none',
              padding: 0,
            }}
            type="button"
            onClick={handleCheckUploadingAndClose}>
            <img src={closeIcon} alt="close" />
          </button>
        </Flex>
      </Segment>
      <Segment className="body">
        {isOngoing ? (
          <SummaryContent
            consult={consult}
            conversation={conversation}
            doctor={doctor}
            hasFinish={false}
            datePickerAppendToBody
          />
        ) : (
          <WrapHealthSummaryDetails consult={consult} />
        )}
      </Segment>
    </Segment.Group>
  );
};

ConsultSummary.propTypes = {
  closeContextMenu: func.isRequired,
  consult: objectOf(
    shape({
      id: string.isRequired,
    }),
  ).isRequired,
};

ConsultSummary.defaultProps = {};

export default ConsultSummary;
